/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { ErrorMessage, useFormikContext } from 'formik'
import { shallowEqual, useSelector } from 'react-redux'
import { PhoneInputProps } from 'react-phone-input-2'
import { RootState } from '../../../../../setup'

const Step2: FC<PhoneInputProps> = () => {

  const formik = useFormikContext()
  const { sectors }: any = useSelector<RootState>(
    (state) => ({
      sectors: state.auth.sectors,
    }),
    shallowEqual
  )

  const [sectorList, setSectorList] = useState([...sectors])

  useEffect(() => {
    setSectorList(sectors)
  }, [sectors])

  interface Sector {
    id: string
    name: string
  }

  const [selectedId, setSelectedId] = useState<{ [key: string]: boolean }>({})

  const onSelectSector = (id: string) => {
    const newSelected = { ...selectedId }
    newSelected[id] = !selectedId[id]
    setSelectedId(newSelected)
    const keys = Object.keys(newSelected)
    const filteredArray = keys.filter((key) => newSelected[key])
    formik.setFieldValue('sectors', filteredArray)
  }

  return (
    <div className='w-100 mt-2 card-body  pt-6 '>
      <div className='pb-8 pb-lg-8 boxTitleHeading'>
        <h2 className='fw-bolder d-flex align-items-center text-dark'>Choose Industry</h2>
      </div>
      <div className='fv-row'>
        <div className='row'>
          {sectorList.map((sector: Sector, index: number) => {
            return (
              <div className='col-lg-6' key={sector.id}>
                <label
                  className={`btn borderIndustry p-7 d-flex align-items-center mb-5 justify-content-center ${selectedId[sector.id] && 'active-industry'
                    }`}
                  htmlFor={sector.name}
                  onClick={() => onSelectSector(sector.id)}
                  tabIndex={0}
                >
                  <span className='d-block fw-bold text-start'>
                    <span
                      className={`text-dark fw-bolder d-block fs-4 indTitle ${selectedId[sector.id] && 'active-title'
                        }`}
                    >
                      {sector.name}
                    </span>
                  </span>
                </label>
              </div>
            )
          })}
        </div>
        <ErrorMessage name='sectors'>
          {(errorMessage) => <div className='text-danger mt-2'>{errorMessage}</div>}
        </ErrorMessage>
      </div>
    </div>
  )
}

export { Step2 }
